const BASE_SPEED = 250;
const speed = {
  verySlow: BASE_SPEED * 4,
  slow: BASE_SPEED * 1.7,
  normal: BASE_SPEED,
  fast: BASE_SPEED * 0.4
};

export { speed };
